import { el } from 'modules/DOM';

export const buildLoadingSpinner = () => {
  const spinner = el('div', { classList: ['spinner-border', 'mx-2'],
                              attributes: { role: 'status', 'aria-hidden': true }});
  const loadingText = el('strong', { text: 'Loading...' });

  return el('div', { classList: ['d-flex', 'align-items-center', 'justify-content-center', 'purple'], children: [spinner, loadingText] });
}